export default __webpack_public_path__ + "static/media/bem-estar.3839b130.png";